import {createSlice} from "@reduxjs/toolkit";

const projectSlice = createSlice({
    name: "projectRedux",
    initialState: {
        projects: [],
        voucherCounts: {}
    },
    reducers: {
        addProject: (state, action) => {
            state.projects.push(action.payload);
            state.voucherCounts = {...state.voucherCounts, [action.payload.projectName] : 0};
        },

        editProject: (state, action) => {
            const updatedProject = action.payload;
            for(const item of state.projects){
                if(item.projectId === updatedProject.projectId){
                    item.projectName = updatedProject.projectName;
                    item.projectDesc = updatedProject.projectDesc;
                    item.projectManager = updatedProject.projectManager;
                    break;
                }
            }
            
        },

        updateProjectVoucherCount: (state, action) => {
            state.voucherCounts[action.payload]++;
        }
        
    }
});

export const {addProject, editProject, updateProjectVoucherCount} = projectSlice.actions;
export default projectSlice.reducer;